// extracted by mini-css-extract-plugin
export default {"container":"WKaB","serviceTitle":"eMKF","serviceData":"pnTy"};